import { useContext, useEffect, useState } from "react";
import styles from "./styles/Search.module.css";
import OutputData from "../../components/ui/output_data/OutputData";
import OutputLocation from "../../components/ui/output_location/OutputLocation";
import OutputWindowAmount from "../../components/ui/output_window_amount/OutputWindowAmount";
import OutputWindowInfo from "../../components/ui/output_window_info/OutputWindowInfo";
import {
    formatDateToLocalDate,
    calculateValues,
    capitalizeFirstLetter,
} from "../../utils/utils";
import { useTranslation } from "react-i18next";
import OutputDataDetails from "../../components/output_data_details/OutputDataDetails";

import DataContext from "../../context/DataContext";

import Instalment from "../../components/ui/instalment/Instalment";
import OutputWindowSettlement from "../../components/ui/output_window_Settlement/OutputWindowSettlement";

import OutputWindow from "../../components/ui/output_window/OutputWindow";
import GetTicketInfoWindowContent from "./get_ticket_info_window_content/GetTicketInfoWindowContent";
import Button from "../../components/ui/button/Button";
import Complaint from "./Complaint";
import { axiosSW } from "../../api/axiosDefaults";

import { ReactComponent as IconTicket } from "../../assets/ticket.svg";
import { ReactComponent as IconCalendarDay } from "../../assets/calendar-day.svg";
import { ReactComponent as IconCalendar } from "../../assets/calendar.svg";
import { ReactComponent as IconHistory } from "../../assets/history.svg";
import { ReactComponent as IconCoins } from "../../assets/coins.svg";
import { ReactComponent as IconGavel } from "../../assets/gavel.svg";
import { ReactComponent as IconExclam } from "../../assets/exclamation.svg";
import OutputScofflaw from "../../components/ui/output_scofflow/OutputScofflaw";
const TicketInfo = ({
    color, // {String} - Color value.
    currency, // {String} - Currency symbol.
    ticket, // {Object} - Ticket data.
    ticketType,
    handleCheckInstalment,
    selectedInstalments,
    currentSettlement,
    selectedSettlements,
    setSelectedInstalments,
}) => {
    const { t } = useTranslation();
    const { connection, handleError, setIsInstallemtHover } =
        useContext(DataContext);
    const [clickedInstalment, setClickedInstalment] = useState(null);
    const [currenInstalment, setCurrenInstalment] = useState(null);

    const [complaintStatus, setComplaintStatus] = useState(null);

    const [showComplaintForm, setShowComplaintForm] = useState(false);

    useEffect(() => {
        if (tempIsNoComplaits && ticket && ticketType === 0) {
            getComplaintStatus();
        }
    }, [ticket?.ticketNo]);

    // ------------------------------------------------- should be from customer configuration
    const tempIsNoComplaits = false;
    // ------------------------------------------------- should be from customer configuration

    const getComplaintStatus = async () => {
        const payLoad = {
            uniqueIdentifier: connection?.uniqueId,
            ticketNo: ticket?.ticketNo,
            fromDateTime: ticket?.from_DateTime,
        };
        try {
            const { data } = await axiosSW.post(
                "/tickets/complaint-status",
                payLoad,
            );

            if (data) {
                getCurrentStatus(data);
            }
        } catch (error) {
            handleError(error);
        }
    };

    const filterTransactionItems = (items, filterStrings) => {
        return (
            items?.length &&
            items.filter((item) => !filterStrings.includes(item?.txt))
        );
    };

    // Get  penalty and total values using calculateValues function from utils. The order of the inputs is IMPORTANT!
    const { penalty, total, tax } = calculateValues(
        ticket?.paymentBalance,
        ticket?.amount,
        ticket?.transactionItems,
    );

    const handleClickedInstalment = (number) => {
        setClickedInstalment(number);
    };

    useEffect(() => {
        if (ticket && ticketType === 1) {
            handleClickedInstalment(
                ticket?.settlementTransactionItems?.[0]?.id,
            );
            setCurrenInstalment(ticket?.settlementTransactionItems?.[0]);
        }
    }, [ticket]);

    const [resetShow, setResetShow] = useState(false);

    useEffect(() => {
        setResetShow((prev) => !prev);
    }, [ticket]);

    const handleComplaintButton = () => {
        setShowComplaintForm((prev) => !prev);
    };

    const getCurrentStatus = (data) => {
        if (
            !typeof data?.status === "string" ||
            !data?.status ||
            data?.ticketNo !== ticket?.ticketNo
        ) {
            setComplaintStatus(null);
            return;
        }

        switch (data?.status.toLowerCase()) {
            case "new":
            case "Processed":
                setComplaintStatus({ text: "complaint filed", status: 0 });
                break;
            case "in progress":
                setComplaintStatus({
                    text: "complaint in progress",
                    status: 1,
                });
                break;
            case "accepted":
                setComplaintStatus({ text: "complaint accepted", status: 2 });
                break;
            case "rejected":
                setComplaintStatus({ text: "complaint rejected", status: 3 });
                break;
            default:
                setComplaintStatus(null);
        }
    };

    // ---------------------------------------------------------------------------------------------------

    const [isSelectedInstallments, setIsSelectedInstallments] = useState(false);
    const [isHoverInstallmentFlag, setIsHoverInstallmentFlag] = useState(false);

    useEffect(() => {
        setIsSelectedInstallments(
            selectedInstalments?.length ===
                ticket?.settlementTransactionItems?.length,
        );
    }, [selectedInstalments]);

    useEffect(() => {
        if (isHoverInstallmentFlag) {
            setIsInstallemtHover(ticket?.caseNo);
        } else {
            setIsInstallemtHover("");
        }
    }, [isHoverInstallmentFlag]);

    const checkDisable = () => {
        return !selectedSettlements.includes(ticket?.caseNo);
    };

    const getMustPaidItems = () => {
        const filteredItems =
            ticket?.settlementTransactionItems.filter(
                (item) => item.status === 0 || item.status === 1,
            ) || [];

        return filteredItems;
    };

    const selectMandatoryInstallment = () => {
        const mustPaid = getMustPaidItems();

        if (mustPaid.length) {
            mustPaid.forEach((item) =>
                setSelectedInstalments((prev) => [
                    ...prev,
                    {
                        instalmentId: item?.id.toString(),
                        amount: item?.netAmount.toString(),
                        instalmentInfo: item?.txt.toString(),
                        instalmentDate: item?.dateAndTime.toString(),
                    },
                ]),
            );
        } else {
            const firstInstalment = ticket?.settlementTransactionItems[0];

            setSelectedInstalments((prev) => [
                ...prev,
                {
                    instalmentId: firstInstalment?.id.toString(),
                    amount: firstInstalment?.netAmount.toString(),
                    instalmentInfo: firstInstalment?.txt.toString(),
                    instalmentDate: firstInstalment?.dateAndTime.toString(),
                },
            ]);
        }
    };

    const handleSelectAllInstallments = () => {
        if (checkDisable()) return;
        setSelectedInstalments([]);
        if (!isSelectedInstallments) {
            // selectMandatoryInstallment();
            // const nonSelectedInstallments = getNonSelectedItems();

            ticket?.settlementTransactionItems?.length &&
                ticket?.settlementTransactionItems.map((item) => {
                    setSelectedInstalments((prev) => [
                        ...prev,
                        {
                            instalmentId: item?.id.toString(),
                            amount: item?.netAmount.toString(),
                            instalmentInfo: item?.txt.toString(),
                            instalmentDate: item?.dateAndTime.toString(),
                        },
                    ]);
                });
        } else {
            selectMandatoryInstallment();
        }
    };

    return (
        <>
            {showComplaintForm ? (
                <div className={` ${styles.pay_form_back}  v-flex-container`}>
                    <Complaint
                        from_DateTime={ticket?.from_DateTime}
                        ticketNo={ticket?.ticketNo}
                        setShowComplaintForm={setShowComplaintForm}
                        complaintStatus={complaintStatus}
                        setComplaintStatus={setComplaintStatus}
                    />
                </div>
            ) : (
                <></>
            )}

            <section
                className={`${styles.main_info_container} ${ticket?.scofflawCaseNumber ? styles.scoffloaw_info_container : ""}  v-flex-container`}
            >
                <h2
                    className={`${styles.main_info_container_header} ${
                        ticketType === 0
                            ? styles.info_container_header_tickets
                            : ""
                    } ${
                        ticketType === 0 && !tempIsNoComplaits
                            ? styles.header_tickets_no_complaint
                            : ""
                    }`}
                >
                    {ticketType === 0
                        ? `${t(`ticket`)} #${ticket?.ticketNo} ${t(`details`)}`
                        : `${t(`settlement`)} #${ticket?.caseNo} ${t(
                              `details`,
                          )}`}
                </h2>

                {tempIsNoComplaits ? (
                    <div
                        className={`${styles.complaint_container} flex-container`}
                    >
                        <div>
                            <div className={`flex-container`}>
                                {complaintStatus ? (
                                    <div
                                        className={`${
                                            styles.complaint_icon_container
                                        } ${
                                            complaintStatus?.status === 1
                                                ? styles.complaint_yellow
                                                : complaintStatus?.status === 2
                                                  ? styles.complaint_green
                                                  : complaintStatus?.status ===
                                                      3
                                                    ? styles.complaint_red
                                                    : ""
                                        } flex-container`}
                                    >
                                        <IconExclam
                                            className={`${styles.complaint_icon} icon-component`}
                                        />
                                    </div>
                                ) : (
                                    <></>
                                )}
                                <span className={`${styles.complaint_text}`}>
                                    {capitalizeFirstLetter(
                                        t(complaintStatus?.text),
                                    )}
                                </span>
                            </div>
                        </div>
                        {ticketType === 0 &&
                        complaintStatus?.status !== 3 &&
                        complaintStatus?.status !== 2 ? (
                            <div
                                className={`${styles.complaint_button_container}`}
                            >
                                <Button
                                    body={
                                        complaintStatus
                                            ? t("add data")
                                            : t("file a complaint")
                                    }
                                    type={"button"}
                                    size={"small"}
                                    onClickFuction={handleComplaintButton}
                                />
                            </div>
                        ) : (
                            <></>
                        )}
                    </div>
                ) : (
                    <></>
                )}

                {ticketType === 0 ? (
                    <>
                        {ticket?.scofflawCaseNumber ? (
                            <div
                                className={`${styles.output_info_container} ${styles.output_scofflaw_container}`}
                            >
                                <OutputScofflaw
                                    header={`${t("scofflaw")}: ${ticket?.scofflawCaseNumber}`}
                                    body={capitalizeFirstLetter(
                                        t("this vehicle has unpaid violations"),
                                    )}
                                />
                            </div>
                        ) : (
                            <></>
                        )}
                        <div
                            className={`${styles.info_container} flex-container`}
                        >
                            <div
                                className={`${styles.info_data_container} v-flex-container`}
                            >
                                <OutputData
                                    label={t(`ticket number`)}
                                    data={ticket?.ticketNo}
                                    icon={IconTicket}
                                />
                                <OutputData
                                    label={t(`ticket date`)}
                                    data={formatDateToLocalDate(
                                        ticket?.from_DateTime,
                                    )}
                                    icon={IconCalendarDay}
                                />
                                <OutputData
                                    label={t(`issue date`)}
                                    data={formatDateToLocalDate(
                                        ticket?.to_DateTime,
                                    )}
                                    icon={IconCalendar}
                                />
                                <OutputLocation
                                    label={t(`location`)}
                                    data={ticket?.street}
                                    icon={"fa-solid fa-location-dot"}
                                    location={ticket?.location}
                                    ticketNumber={ticket?.ticketNo}
                                />
                            </div>
                            <div
                                className={`${styles.info_windows_container} v-flex-container`}
                            >
                                {/* Amount window */}
                                <div
                                    className={`${styles.output_amount_container}`}
                                >
                                    <OutputWindowAmount
                                        amount={parseInt(ticket?.amount)}
                                        penalty={penalty}
                                        total={total}
                                        tax={tax}
                                        currency={currency}
                                    />
                                </div>
                            </div>
                        </div>
                        {/* Violations window */}
                        <div className={`${styles.output_info_container}`}>
                            <OutputWindowInfo
                                exKey={ticket?.ticketNo}
                                header={t(`violation`)}
                                body={ticket?.offences}
                            />
                        </div>
                        <div className={`${styles.output_info_container}`}>
                            <OutputDataDetails
                                reset={resetShow}
                                label={t(`charges`)}
                                data={filterTransactionItems(
                                    ticket?.transactionItems,
                                    ["Offence amount"],
                                )}
                                notAvialableMessage={t(`no charges`)}
                                icon={IconHistory}
                                placeHolder={t("view charges")}
                            />
                        </div>
                    </>
                ) : (
                    <>
                        <div
                            className={`${styles.info_container} flex-container`}
                        >
                            <div
                                className={`${styles.info_data_container} v-flex-container`}
                            >
                                <OutputData
                                    label={t(`case number`)}
                                    data={ticket?.caseNo}
                                    icon={IconGavel}
                                />

                                <OutputData
                                    label={t(`paid instalments`)}
                                    data={`paid ${ticket?.paidInstallments} ${t(
                                        `out of `,
                                    )} ${ticket?.totalInstallments} `}
                                    icon={IconCoins}
                                />
                                <OutputDataDetails
                                    label={t(`tickets`)}
                                    data={ticket?.includedTicketNumbers}
                                    notAvialableMessage={t(`no tickets`)}
                                    icon={IconTicket}
                                    placeHolder={t("view tickets")}
                                />
                            </div>

                            <div
                                className={`${styles.info_windows_container} v-flex-container`}
                            >
                                {/* Amount window */}
                                <div
                                    className={`${styles.output_amount_container}`}
                                >
                                    <OutputWindowSettlement
                                        fullAmount={ticket?.totalAmount}
                                        remain={ticket?.remainingAmount}
                                        currency={currency}
                                    />
                                </div>
                                {/* Violations window */}
                            </div>
                        </div>

                        <div className={`${styles.ticket_info_divider}`}></div>

                        <div
                            className={`${styles.main_settlement_container} flex-container`}
                        >
                            <div
                                className={`${styles.settlements_container} v-flex-container`}
                            >
                                {ticket?.settlementTransactionItems &&
                                ticket?.settlementTransactionItems?.length >
                                    1 ? (
                                    <div
                                        className={`${styles.sellect_all_container} flex-container`}
                                    >
                                        {connection?.isPayment ? (
                                            <div
                                                className={`${styles.sellect_all_button_container}`}
                                            >
                                                <Button
                                                    body={
                                                        !isSelectedInstallments
                                                            ? t(
                                                                  "select all installments",
                                                              )
                                                            : t(
                                                                  "deselect all installments",
                                                              )
                                                    }
                                                    size={"small"}
                                                    onClickFuction={
                                                        handleSelectAllInstallments
                                                    }
                                                    fullWidth={true}
                                                    setHoverFlag={
                                                        setIsHoverInstallmentFlag
                                                    }
                                                    disabled={checkDisable()}
                                                />
                                            </div>
                                        ) : (
                                            <></>
                                        )}
                                    </div>
                                ) : (
                                    <></>
                                )}

                                {ticket?.settlementTransactionItems.filter(
                                    (item) =>
                                        item?.status === 0 ||
                                        item?.status === 1,
                                ).length ? (
                                    <>
                                        <h4
                                            className={`${styles.instalments_header} `}
                                        >
                                            {t(`mandatory payments`)}:
                                        </h4>
                                        <div
                                            className={`${styles.mandetory_container} v-flex-container`}
                                        >
                                            {ticket?.settlementTransactionItems.map(
                                                (transaction) => {
                                                    if (
                                                        transaction?.status ===
                                                            0 ||
                                                        transaction?.status ===
                                                            1
                                                    )
                                                        return (
                                                            <Instalment
                                                                caseNo={
                                                                    ticket?.caseNo
                                                                }
                                                                key={
                                                                    transaction?.id
                                                                }
                                                                selectedSettlements={
                                                                    selectedSettlements
                                                                }
                                                                selectedInstalments={
                                                                    selectedInstalments
                                                                }
                                                                setCurrenInstalment={
                                                                    setCurrenInstalment
                                                                }
                                                                clickedInstalment={
                                                                    clickedInstalment
                                                                }
                                                                handleClickedInstalment={
                                                                    handleClickedInstalment
                                                                }
                                                                instalment={
                                                                    transaction
                                                                }
                                                                handleCheckFunction={
                                                                    handleCheckInstalment
                                                                }
                                                                currency={
                                                                    currency
                                                                }
                                                            />
                                                        );
                                                },
                                            )}
                                        </div>
                                    </>
                                ) : (
                                    <></>
                                )}
                                {ticket?.settlementTransactionItems.filter(
                                    (item) => item?.status === 2,
                                ).length ? (
                                    <h4
                                        className={`${styles.instalments_header} `}
                                    >
                                        {t(`upcoming payments`)}:
                                    </h4>
                                ) : (
                                    <></>
                                )}
                                <div
                                    className={`${styles.upcoming_container} v-flex-container`}
                                >
                                    {ticket?.settlementTransactionItems.map(
                                        (transaction) => {
                                            if (transaction?.status === 2)
                                                return (
                                                    <Instalment
                                                        caseNo={ticket?.caseNo}
                                                        key={transaction?.id}
                                                        selectedSettlements={
                                                            selectedSettlements
                                                        }
                                                        selectedInstalments={
                                                            selectedInstalments
                                                        }
                                                        setCurrenInstalment={
                                                            setCurrenInstalment
                                                        }
                                                        clickedInstalment={
                                                            clickedInstalment
                                                        }
                                                        handleClickedInstalment={
                                                            handleClickedInstalment
                                                        }
                                                        instalment={transaction}
                                                        searched={false}
                                                        handleCheckFunction={
                                                            handleCheckInstalment
                                                        }
                                                        currency={currency}
                                                    />
                                                );
                                        },
                                    )}
                                </div>
                            </div>
                            <div
                                className={`${styles.settlement_window_container} flex-container`}
                            >
                                <OutputWindow
                                    content={
                                        <GetTicketInfoWindowContent
                                            installment={currenInstalment}
                                            currency={currency}
                                        />
                                    }
                                    inheritCorner={true}
                                    stretch={true}
                                />
                            </div>
                        </div>
                    </>
                )}
            </section>
        </>
    );
};

export default TicketInfo;
